import { memo } from 'react';
import { AdminFormRow, AdminFormSection } from '@ui';
import { ControlledSelect } from '@lp/features/admin/forms/components/inputs/ControlledSelect';
import { TC_LEVEL } from '../../config';

type ClinicalCoordinatorSpecificationSectionProps = {
  isReadOnly?: boolean;
};

export const ClinicalCoordinatorSpecificationSection = memo(
  ({ isReadOnly }: ClinicalCoordinatorSpecificationSectionProps) => {
    return (
      <AdminFormSection title="Clinical Coordinator Specification">
        <AdminFormRow title="TC Level" isRequired>
          <ControlledSelect
            name="clinicalCoordinatorType"
            placeholder="Choose an option"
            aria-label="TC Level"
            isDisabled={isReadOnly}
            items={TC_LEVEL}
          />
        </AdminFormRow>
      </AdminFormSection>
    );
  },
);
